import React from 'react';
import PropTypes from 'prop-types';
import { configuredRadium } from 'utils/General';

const styles = {
  button: {
    width: '32px',
    height: '32px',
    border: 'none',
    backgroundColor: '#F2F5FC',
    borderRadius: '50%',
    padding: '5px',
    cursor: 'pointer',
    WebkitBoxShadow: '2px 2px 5px rgba(35, 86, 210, 0.2)',
    MozBoxShadow: '2px 2px 5px rgba(35, 86, 210, 0.2)',
    boxShadow: '2px 2px 5px rgba(35, 86, 210, 0.2)',
  },
};

const SubtractButton = ({ handleClick, additionalStyles }) => (
  <button
    type="button"
    onClick={handleClick}
    style={[styles.button, additionalStyles]}
  >
    -
  </button>
);

SubtractButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  additionalStyles: PropTypes.object,
};

SubtractButton.defaultProps = {
  additionalStyles: {},
};

export default configuredRadium(SubtractButton);



// WEBPACK FOOTER //
// ./src/components/tariff/icons/SubtractButton.jsx